import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../lib/api';

const WholesaleAuthContext = createContext();

export const useWholesaleAuth = () => {
    const context = useContext(WholesaleAuthContext);
    if (!context) {
        throw new Error('useWholesaleAuth must be used within a WholesaleAuthProvider');
    }
    return context;
};

export const WholesaleAuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem('wayside-wholesale-token'));
    const [customer, setCustomer] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyToken = async () => {
            if (token) {
                try {
                    const response = await axios.get(`${API}/wholesale/me`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    setCustomer(response.data);
                    setIsAuthenticated(true);
                } catch {
                    localStorage.removeItem('wayside-wholesale-token');
                    setToken(null);
                    setCustomer(null);
                    setIsAuthenticated(false);
                }
            }
            setLoading(false);
        };
        verifyToken();
    }, [token]);

    const login = async (email, password) => {
        const response = await axios.post(`${API}/wholesale/login`, { email, password });
        const newToken = response.data.access_token;
        localStorage.setItem('wayside-wholesale-token', newToken);
        setToken(newToken);
        const me = await axios.get(`${API}/wholesale/me`, {
            headers: { Authorization: `Bearer ${newToken}` }
        });
        setCustomer(me.data);
        setIsAuthenticated(true);
        return true;
    };

    const logout = () => {
        localStorage.removeItem('wayside-wholesale-token');
        setToken(null);
        setCustomer(null);
        setIsAuthenticated(false);
    };

    const getAuthHeaders = () => ({
        Authorization: `Bearer ${token}`
    });

    return (
        <WholesaleAuthContext.Provider value={{
            token,
            customer,
            isAuthenticated,
            loading,
            login,
            logout,
            getAuthHeaders,
        }}>
            {children}
        </WholesaleAuthContext.Provider>
    );
};
